import { render, staticRenderFns } from "./PrivateHeading.vue?vue&type=template&id=0c93f21a&scoped=true&"
import script from "./PrivateHeading.vue?vue&type=script&lang=js&"
export * from "./PrivateHeading.vue?vue&type=script&lang=js&"
import style0 from "./PrivateHeading.vue?vue&type=style&index=0&id=0c93f21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c93f21a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
